export default function getTooltipPos(element: HTMLDivElement | null) {
  if (element === null) {
    return 'bottom';
  }
  return element.getBoundingClientRect().x < window.innerWidth / 2 ? "right" : "left";
}